import React from "react";

const BottomControls = ({
  handleGoBack,
  previousPage,
  nextPage,
  currentPage,
  totalPages,
  zoom,
  fitWidthZoom,
  zoomIn,
  zoomOut,
  fitMode,
  toggleFit,
}) => {
  const zoomPct = Math.round((zoom / fitWidthZoom) * 100);

  // clamp between 0 and some max if you like:
  const displayPct = Math.max(0, Math.min(zoomPct, 999));

  return (
    <div className="absolute inset-x-0 bottom-3 mx-auto z-40 bg-gray-800 rounded p-1 w-fit max-w-lg  flex justify-center items-center gap-4 shadow-md">
      <button
        data-tooltip-id="global-tooltip"
        data-tooltip-content="Home"
        onClick={handleGoBack}
        className="text-xs p-1 px-2 hover:text-tier-secondary hover:bg-gray-500 rounded"
      >
        <span className="material-symbols-outlined text-sm">home</span>
      </button>

      <div className="flex flex-row">
        <button
          data-tooltip-id="global-tooltip"
          data-tooltip-content="Previous Page"
          onClick={previousPage}
          className="text-xs flex items-center p-1 hover:text-tier-secondary hover:bg-gray-500 rounded"
        >
          <span className="material-symbols-outlined text-sm">
            arrow_back_ios
          </span>
        </button>

        <span className="text-xs p-2 rounded bg-gray-700">
          Page {currentPage} of {totalPages}
        </span>

        <button
          data-tooltip-id="global-tooltip"
          data-tooltip-content="Next Page"
          onClick={nextPage}
          className="text-xs flex items-center p-1 hover:text-tier-secondary hover:bg-gray-500 rounded"
        >
          <span className="material-symbols-outlined text-sm">
            arrow_forward_ios
          </span>
        </button>
      </div>

      <div className="flex">
        <button
          data-tooltip-id="global-tooltip"
          data-tooltip-content="Zoom in"
          onClick={zoomIn}
          className="text-xs p-1 px-2 hover:text-tier-secondary hover:bg-gray-500 rounded"
        >
          <span className="material-symbols-outlined text-base">zoom_in</span>
        </button>

        <button
          data-tooltip-id="global-tooltip"
          data-tooltip-content="Zoom out"
          onClick={zoomOut}
          className="text-xs p-1 px-2 hover:text-tier-secondary hover:bg-gray-500 rounded"
        >
          <span className="material-symbols-outlined text-base">zoom_out</span>
        </button>

        <span className="text-xs p-2 rounded bg-gray-700">{displayPct}%</span>
      </div>

      {/* single toggle button */}
      <button
        data-tooltip-id="global-tooltip"
        data-tooltip-content={
          fitMode === "width" ? "Fit to width" : "Fit to Page"
        }
        onClick={toggleFit}
        title={
          fitMode === "width"
            ? "Currently fit-to-width → switch to fit-to-height"
            : "Currently fit-to-height → switch to fit-to-width"
        }
        className="text-xs p-1 px-2 hover:text-tier-secondary hover:bg-gray-500 rounded"
      >
        <span className="material-symbols-outlined text-base">
          {fitMode === "width" ? "fit_width" : "fit_page"}
        </span>
      </button>
    </div>
  );
};

export default BottomControls;
